import { render, staticRenderFns } from "./menuTorole.vue?vue&type=template&id=7d13d714&scoped=true&"
import script from "./menuTorole.vue?vue&type=script&lang=js&"
export * from "./menuTorole.vue?vue&type=script&lang=js&"
import style0 from "./menuTorole.vue?vue&type=style&index=0&id=7d13d714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d13d714",
  null
  
)

export default component.exports